import React from "react";
import "./message.css";

export default function Message() {
  return <div className="message">Message</div>;
}
